// extracted by mini-css-extract-plugin
module.exports = {"linkLists":"LinkLists_linkLists__XS9C7","column":"LinkLists_column__ExpWM","moreNews":"LinkLists_moreNews__aM_Y7"};